import { LorenAsset } from "../loren-assets/interfaces/loren-asset.interface";
import { LorenMeteringType } from "../loren-assets/interfaces/loren-metering-type";
import { LatLngLiteral } from "leaflet";

export function getAssetLocation(asset: LorenAsset): LatLngLiteral | null {
  const tracker = asset.metering.find((m) => m.type === LorenMeteringType.GPS_TRACKER_SENSOR);

  if (tracker) {
    const latitude = tracker.data.find((k) => k.key === "lat")?.value;
    const longitude = tracker.data.find((k) => k.key === "lng")?.value;

    if (latitude && longitude) {
      return {
        lat: Number(latitude),
        lng: Number(longitude),
      };
    }
  }

  if(asset.defaultLocation?.latitude && asset.defaultLocation?.longitude) {
    return {
      lat: asset.defaultLocation.latitude,
      lng: asset.defaultLocation.longitude,
    }
  }

  return null;
}